export default __webpack_public_path__ + "static/media/error-icon.a47e79a6.svg";